import React, { useState } from 'react';
import { CreateJobDialog } from '../create-job-dialog';
import { ConfirmationModal } from 'components';
import { Grid, Typography } from '@mui/material';
import { styles as confirmationModalStyles } from 'components/confirmation-modal/confirmation-modal-helper';
import { useWipeSDZDataJob } from '../../../../hooks';
import { useAuth } from '../../../../core';
import { useNavigate } from 'react-router-dom';
import { JOB_MANAGER_PATHS } from 'constants/job-manager-paths';
import { wipeOrResetSdzDataJobStyle } from 'pages/job-manager/job-manager-helper';

export const CreateWipeSDZData = (): React.JSX.Element => {
    const { getToken, getUserEmail } = useAuth();
    const navigate = useNavigate();
    const { mutate: wipeSDZDataJob } = useWipeSDZDataJob();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
    const handleResetButton = (): void => {
        setConfirmationModal(true);
    };
    const handleConfirmationModal = (): void => {
        setConfirmationModal(false);
    };
    const handleWipeData = (): void => {
        setIsLoading(true);
        wipeSDZDataJob(
            {
                token: getToken(),
                email: getUserEmail(),
            },
            {
                onSuccess: () => {
                    setTimeout(() => {
                        navigate(JOB_MANAGER_PATHS.LANDING_PAGE);
                    }, 500);
                    setIsLoading(false);
                    handleConfirmationModal();
                },
                onError: () => {
                    setIsLoading(false);
                    handleConfirmationModal();
                },
            }
        );
    };
    return (
        <>
            <CreateJobDialog
                handleSubmit={handleResetButton}
                buttonText='WIPE DATA'
                isLoading={isLoading}
                customButtonContainerStyles={
                    wipeOrResetSdzDataJobStyle.customButtonContainerStyles
                }
            >
                <Grid sx={wipeOrResetSdzDataJobStyle.container}>
                    <Typography sx={wipeOrResetSdzDataJobStyle.textStyles}>
                        The wipe job will permanently delete all chain data,
                        including blobs, edge <br /> definitions, user wallets,
                        job history, uploads, and downloads. Metadata will{' '}
                        <br /> remain. This action CANNOT be undone. Are you
                        sure you want to <br /> proceed?
                    </Typography>
                </Grid>
            </CreateJobDialog>
            {confirmationModal && (
                <ConfirmationModal
                    confirmationModal={confirmationModal}
                    handleConfirmationModal={handleConfirmationModal}
                    confirmationKey={'WIPE'}
                    confirmationButtonText={'Wipe Data'}
                    confirmationHeadingText={'Confirm Wipe'}
                    confirmationInputLabelText={'Type WIPE below'}
                    handleConfirmation={handleWipeData}
                    confirmationSubHeadingText={
                        <Typography>
                            By typing{' '}
                            <Typography
                                component='span'
                                sx={confirmationModalStyles.textBoldStyles}
                            >
                                ‘WIPE’
                            </Typography>{' '}
                            below, you understand that you are wiping all chain
                            data. This action{' '}
                            <Typography
                                component='span'
                                sx={confirmationModalStyles.textBoldStyles}
                            >
                                CANNOT
                            </Typography>{' '}
                            be undone.
                        </Typography>
                    }
                />
            )}
        </>
    );
};
